import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Routes, provideRouter } from '@angular/router';
import { AppComponent } from 'app/app.component';
import { TradeFinanceRootRoutes } from 'app/app.routes';
import { TradeFinanceMarketingComponent } from 'app/routes/trade-finance-marketing/trade-finance-marketing.component';

import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { MaterialModule } from 'app/material.module';
import { AuthGuard } from 'app/routes/sessions/login/auth.guard';
import { BasicAuthInterceptor } from 'app/routes/sessions/login/basic-auth.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

if (environment.production) {
  enableProdMode();
}

if (window.location.host === 'tradefinance.dpworld.com' || window.location.host === 'qa-tradefinance.dpworld.com') {
  const routes: Routes = [
    { path: '', component: TradeFinanceMarketingComponent },
    { path: '**', redirectTo: '' },
    { path: 'def', redirectTo: '' }
  ];
  bootstrapApplication(TradeFinanceMarketingComponent, {
    providers: [provideAnimations(), provideRouter(routes)]
  }).then((ref) => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;
  })
    .catch(err => console.log(err));
} else {
  bootstrapApplication(AppComponent, {
    providers: [
      { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
      provideAnimations(),
      provideRouter(TradeFinanceRootRoutes),
      provideHttpClient(withInterceptorsFromDi()),
      DatePipe,
      AuthGuard,
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
      GoogleTagManagerService,
      importProvidersFrom(MaterialModule),
      {
        provide: APP_BASE_HREF,
        useValue: window['_app_base'] || '/'
      },
      { provide: 'googleTagManagerId', useValue: environment.enableGTAGID ? (environment.environmentName === 'Prod' ? environment.GTAG_ID : environment.GTAG_ID_NON_PROD) : 'DUMMY' },
    ]
  }).then((ref) => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;
  })
    .catch(err => console.error('Error during bootstrap:', err));
}
